<template>
  <Card class="layout-card" style="height: 100%">
    <Tabs
      v-model="searchForm.goodsChannel"
      @on-click="() => getData()"
      style="flex-shrink: 0"
    >
      <TabPane label="iOS" name="0" />
      <TabPane label="Android" name="1" />
    </Tabs>
    <div class="toolbar-row">
      <div
        style="
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          flex-shrink: 0;
        "
      >
        <div class="search-form" style="width: 100%">
          <Row
            :gutter="10"
            type="flex"
            align="middle"
            style="flex-wrap: nowrap"
          >
            <Col>
              <Input
                :maxlength="100"
                v-model="searchForm.goodsName"
                placeholder="请输入付费项名称"
                style="width: 160px"
              />
            </Col>
            <Col>
              <div style="width: 250px">
                <MultiCascader
                  :data="countryLi"
                  v-model="searchForm.countryCodeList"
                  placeholder="请选择国家"
                  :max-tag-count="1"
                />
              </div>
            </Col>
            <Col>
              <Select
                style="width: 130px"
                placeholder="请选择付费类型"
                v-model="searchForm.goodsType"
                clearable
              >
                <Option
                  v-for="(item, index) in dict.changeType"
                  :key="index"
                  :value="item.key"
                  >{{ item.value }}
                </Option>
              </Select>
            </Col>
            <Col>
              <Select
                style="width: 130px"
                placeholder="请选择第三方折扣"
                v-model="searchForm.thirdPartyDiscount"
                clearable
              >
                <Option :value="0">Stripe</Option>
                <Option :value="1">Antom</Option>
                <Option :value="2">PayPal</Option>
              </Select>
            </Col>
            <Col>
              <Select
                style="width: 100px"
                placeholder="请选择状态"
                v-model="searchForm.goodsStatus"
                clearable
              >
                <Option :value="0">开启</Option>
                <Option :value="1">关闭</Option>
              </Select>
            </Col>
            <Col>
              <Button
                type="primary"
                @click="getData()"
                >查询</Button
              >
              <Button @click="handleReset()" style="margin-left: 10px"
                >重置</Button
              >
            </Col>
          </Row>
        </div>
        <div>
          <Button
            type="primary"
            @click="handleOpenEditModal()"
            >添加</Button
          >
        </div>
      </div>
      <div style="flex: 1; overflow: auto; min-height: 0">
        <Table :data="tableData" :columns="columns" :loading="tableLoading">
          <template #goodsFirstCharge="{ row, index }">
            <div>
              <div v-if="row.goodsType === 0">
                <i-switch
                  :value="row.goodsFirstCharge"
                  :before-change="() => handleChangeFirstCharge(row)"
                  @on-change="row.goodsFirstCharge = $event"
                ></i-switch>
              </div>
              <div v-else>-</div>
            </div>
          </template>
          <template #goodsStatus="{ row, index }">
            <div>
              <i-switch
                :value="row.goodsStatus === 0"
                @on-change="(val) => handleChangeStatus(row, val)"
              ></i-switch>
            </div>
          </template>
          <template #discountGoodsPrice="{ row }">
            <div>
              <template v-if="row.discountGoodsPrice || row.discountGoodsPrice === 0">
                {{ row.discountGoodsPrice }}
              </template>
              <template v-else>-</template>
            </div>
          </template>
          <template #action="{ row }">
            <div>
              <a
                style="margin-left: 10px"
                @click="handleOpenEditModal(row)"
                >编辑</a
              >
              <Poptip
                confirm
                title="确定要删除吗？"
                transfer
                @on-ok="handleDel(row)"
                ><a style="margin-left: 10px; color: red">删除</a></Poptip
              >
            </div>
          </template>
          <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
      </div>
    </div>

    <Modal
      v-model="editVisible"
      :title="(form.id ? '编辑' : '新增') + '付费项'"
      :width="800"
    >
      <div v-if="editVisible">
        <Form
          @submit.native.prevent
          :label-width="180"
          :model="form"
          ref="formRef"
        >
          <FormItem
            label="付费项名称："
            prop="goodsName"
            :rules="[{ required: true, message: '请输入付费项名称' }]"
          >
            <Input :maxlength="100" v-model="form.goodsName" />
          </FormItem>
          <FormItem
            label="指定国家："
            multiple
            prop="countryCodeList"
            required
            :rules="[
              {
                validator: (rule, value, callback) => {
                  if (form.worldWide) {
                    callback()
                    return
                  }
                  if (
                    !form.countryCodeList ||
                    form.countryCodeList.length === 0
                  ) {
                    callback('请选择国家')
                  } else {
                    callback()
                  }
                }
              }
            ]"
          >
            <i-switch
              size="large"
              v-model="form.worldWide"
              :true-value="false"
              :false-value="true"
              @on-change="form.countryCodeList = []"
            >
              <span slot="open">开启</span>
              <span slot="close">关闭</span>
            </i-switch>
            <!-- <Input :maxlength="100" v-model="form.goodsName" /> -->
            <MultiCascader
              v-if="!form.worldWide"
              :data="countryLi"
              v-model="form.countryCodeList"
            />
          </FormItem>
          <FormItem
            label="系统："
            prop="goodsChannel"
            :rules="[{ required: true, message: '请选择系统' }]"
          >
            <RadioGroup
              type="button"
              button-style="solid"
              v-model="form.goodsChannel"
              @on-change="changeChannel"
            >
              <Radio
                v-for="(item, index) in dict.channel"
                :key="index"
                :value="item.key"
                :label="item.key"
                >{{ item.value }}</Radio
              >
            </RadioGroup>
          </FormItem>
          <FormItem
            label="付费类型："
            prop="goodsType"
            :rules="[{ required: true, message: '请选择付费类型' }]"
          >
            <!-- <Select placeholder="请选择付费类型" :disabled="!!form.id" v-model="form.goodsType" @on-change="()=>{
              form = {
                ...form,
                vipExpireTime: null,
                vipOriginalPrice: null,
                goodsDesc: null,
                goodsNum: null,
                goodsReward: null,
                goodsDayReward: null,
                thirdReward: null
              }
            }">
              <Option v-for="(item, index) in dict.changeType" :key="index" :value="item.key">{{
                item.value }}
              </Option>
            </Select> -->
            <RadioGroup
              type="button"
              button-style="solid"
              :disabled="!!form.id"
              v-model="form.goodsType"
              @on-change="
                () => {
                  form = {
                    ...form,
                    vipExpireTime: null,
                    vipOriginalPrice: null,
                    goodsDesc: null,
                    goodsNum: null,
                    goodsReward: null,
                    goodsDayReward: null,
                    thirdReward: null,
                    isShowDiscount: false,
                    discount: null,
                    discountPeriodCount: null,
                    discountGoodsKey: null,
                    thirdDiscountList: [
                      { status: 0, discountPrice: null, discountPeriod: null, giftCoins: null, discountType: 0, payProvider: 0, payMethod: null },
                      { status: 0, discountPrice: null, discountPeriod: null, giftCoins: null, discountType: 0, payProvider: 1, payMethod: null },
                      { status: 0, discountPrice: null, discountPeriod: null, giftCoins: null, discountType: 0, payProvider: 2, payMethod: null }
                    ]
                  }
                }
              "
            >
              <Radio
                v-for="(item, index) in dict.changeType"
                :key="index"
                :value="item.key"
                :label="item.key"
                >{{ item.value }}</Radio
              >
            </RadioGroup>
          </FormItem>

          <Row
            v-if="form.goodsType == 1"
            style="
              border: 1px dashed #000;
              border-radius: 10px;
              padding: 20px 20px 0 0;
              margin: 20px 0;
            "
          >
            <Col v-if="form.goodsChannel !== 1" :span="12" :key="1">
              <FormItem
                label="VIP有效时长(天)："
                prop="vipExpireTime"
                :rules="[
                  { required: true, message: '请选择有效时长' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1
                        ? form.goodsChannel !== 1 && callback('请选择有效时长')
                        : callback()
                  }
                ]"
              >
                <Select
                  v-model="form.vipExpireTime"
                  placeholder="请选择有效时长"
                >
                  <Option :value="7">一周</Option>
                  <Option :value="30">一个月</Option>
                  <Option :value="365">一年</Option>
                </Select>
              </FormItem>
            </Col>
            <Col v-else :span="12" :key="2">
              <FormItem
                label="VIP有效时长："
                prop="vipExpireTime"
                :rules="[{ required: true, message: '请选择有效时长' }]"
              >
                <Select
                  v-model="form.vipExpireTime"
                  placeholder="请选择有效时长"
                  @on-change="
                    () => {
                      form.discountGoodsKey = null
                      form.discount = 0
                      form.iosDiscountOfferId = null
                    }
                  "
                >
                  <Option :value="1">一周</Option>
                  <Option :value="3">一个月</Option>
                  <Option :value="9">一年</Option>
                </Select>
              </FormItem>
            </Col>
            <!-- <Col :span="12">
            <FormItem label="VIP原价（元）：" prop="vipOriginalPrice"
              :rules="[{ validator: (rule, value, callback) => value < 0 ? callback('价格应大于等于0') : callback() }]">
              <InputNumber :min="0" v-model="form.vipOriginalPrice" :max="99999" />
            </FormItem>
            </Col>
            <Col :span="24">
            <FormItem label="付费说明：" prop="goodsDesc" :rules="[{ required: true, message: '请输入付费说明' }]">
              <Input :maxlength="100" v-model="form.goodsDesc" />
            </FormItem>
            </Col> -->
          </Row>
          <Row
            v-if="form.goodsType == 0"
            style="
              border: 1px dashed #000;
              border-radius: 10px;
              padding: 20px 20px 0 0;
              margin: 20px 0;
            "
          >
            <Col :span="12">
              <FormItem
                label="金币数："
                prop="goodsNum"
                :rules="[
                  { required: true, message: '请输入金币数' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsNum"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem
                label="赠送金币数："
                prop="goodsReward"
                :rules="[{ required: true, message: '请输入赠送金币数' }]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsReward"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
          </Row>
          <Row
            v-if="form.goodsType == 2"
            style="
              border: 1px dashed #000;
              border-radius: 10px;
              padding: 20px 20px 0 0;
              margin: 20px 0;
            "
          >
            <Col :span="12">
              <FormItem
                label="通行证有效时长(天)："
                prop="vipExpireTime"
                :rules="[
                  { required: true, message: '请输入有效时长' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <Select
                  v-model="form.vipExpireTime"
                  placeholder="请选择有效时长"
                >
                  <Option :value="7">一周</Option>
                  <Option :value="30">一个月</Option>
                  <Option :value="365">一年</Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem
                label="金币数："
                prop="goodsNum"
                :rules="[
                  { required: true, message: '请输入金币数' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsNum"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem
                label="赠送金币数："
                prop="goodsReward"
                :rules="[
                  { required: true, message: '请输入赠币数' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsReward"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
            <Col :span="6">
              <FormItem
                label="日登录赠币数："
                prop="goodsDayReward"
                :rules="[
                  { required: true, message: '请输入日登录赠币数' },
                  {
                    validator: (rule, value, callback) =>
                      value < 1 ? callback('请输入正整数') : callback()
                  }
                ]"
              >
                <InputNumber
                  :min="0"
                  v-model="form.goodsDayReward"
                  :precision="0"
                  :max="99999"
                />
              </FormItem>
            </Col>
          </Row>

          <FormItem
            label="价格（美元）："
            prop="goodsPrice"
            :rules="[
              { required: true, message: '请输入价格' },
              {
                validator: (rule, value, callback) =>
                  value == 0 ? callback('价格应大于0') : callback()
              }
            ]"
          >
            <InputNumber :min="0" v-model="form.goodsPrice" :max="99999" />
          </FormItem>
          <!-- 内购购买 key -->
          <FormItem
            label="内购购买 key："
            prop="goodsKey"
            :rules="[{ required: true, message: '请输入内购购买 key' }]"
          >
            <Input :maxlength="100" v-model="form.goodsKey" />
          </FormItem>

          <!-- 内购折扣 -->
          <div
            v-if="form.goodsType == 1 || form.goodsType == 2"
            style="border: 1px solid #e4e7ed; border-radius: 6px"
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 8px;
                border-radius: 6px;
                background: #fafafa;
              "
            >
              <span>内购折扣</span>
              <div style="display: flex; align-items: center">
                <i-switch v-model="form.discountStatus" />
              </div>
            </div>

            <template v-if="form.discountStatus">
              <Row style="margin: 8px 0px">
                <Col :span="12">
                  <FormItem
                    v-if="form.goodsType == 1 || form.goodsType == 2"
                    prop="discountGoodsPrice"
                    :rules="[
                      {
                        required: true,
                        message: '请输入新用户内购折扣价',
                        validator: (rule, value, callback) =>
                          !value
                            ? callback('请输入新用户内购折扣价')
                            : callback()
                      }
                    ]"
                  >
                    <template slot="label">
                      新用户内购折扣价
                      <Tooltip
                        content="用户实际支付的价格由下方商店申请的内购折扣key决定，这里设置的数值用于客户端 ui 展示"
                        max-width="200"
                        transfer
                      >
                        <Icon type="ios-help-circle-outline" />
                      </Tooltip>
                      ：
                    </template>
                    <Input
                      :maxlength="100"
                      v-model="form.discountGoodsPrice"
                      placeholder="例：4.99"
                    />
                  </FormItem>
                </Col>
                <Col :span="12">
                  <FormItem
                    v-if="form.goodsType == 1 || form.goodsType == 2"
                    prop="discountPeriodCount"
                    key="discountPeriodCount"
                    :rules="[
                      {
                        required: true,
                        type: 'number',
                        message: '请输入新用户前N' + discountPeriodUnit + '折扣'
                      }
                    ]"
                  >
                    <template slot="label">
                      新用户前N{{ discountPeriodUnit }}折扣
                      <Tooltip
                        content="用户实际折扣周期由下方商店申请的内购折扣key决定，这里设置的数值用于客户端 ui 展示"
                        max-width="200"
                        transfer
                      >
                        <Icon type="ios-help-circle-outline" />
                      </Tooltip>
                      ：
                    </template>
                    <div style="display: flex; flex-direction: column">
                      <InputNumber
                        :precision="0"
                        :maxlength="99999"
                        v-model="form.discountPeriodCount"
                        :min="0"
                      />
                    </div>
                  </FormItem>
                </Col>
              </Row>

              <FormItem
                v-if="form.goodsType == 1 || form.goodsType == 2"
                label="新用户折扣key："
                prop="discountGoodsKey"
                :rules="[
                  {
                    required: true,
                    message: '请输入新用户折扣key',
                    validator: (rule, value, callback) =>
                      !form.discountGoodsKey
                        ? callback('请输入新用户折扣key')
                        : callback()
                  }
                ]"
              >
                <Input
                  :maxlength="100"
                  style="width: 400px"
                  v-model="form.discountGoodsKey"
                />
              </FormItem>
            </template>
          </div>

          <!-- 三方折扣配置 -->
          <div
            style="
              border: 1px solid #e4e7ed;
              border-radius: 6px;
              margin: 10px 0px;
            "
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 10px 8px;
                border-radius: 6px;
                background: #fafafa;
              "
            >
              <span>三方折扣配置</span>
              <div style="display: flex; align-items: center">
                <Button size="small" @click="handleSyncThirdDiscount($event)"
                  >同步配置</Button
                >
              </div>
            </div>
            <div
              v-for="(item, index) in form.thirdDiscountList"
              :key="index"
              style="
                border: 1px solid #e4e7ed;
                border-radius: 6px;
                margin: 10px 10px;
                overflow: hidden;
              "
            >
              <!-- 渠道标题 + 总开关 -->
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 10px 12px;
                  background: #fafafa;
                  border-bottom: 1px solid #e4e7ed;
                "
              >
                <span style="font-weight: 500; color: #333"
                  >{{ channelLabel(item.payProvider) }}</span
                >
                <div style="display: flex; align-items: center">
                  <span style="margin-right: 8px; color: #666; font-size: 13px"
                    >三方支付折扣</span
                  >
                  <i-switch
                    :value="item.status"
                    :true-value="1"
                    :false-value="0"
                    @on-change="(val) => handleThirdDiscountToggle(index, val)"
                  />
                </div>
              </div>

              <!-- 渠道启用后的内容 -->
              <div
                v-if="item.status"
                style="padding: 12px 12px 4px"
              >
                <!-- 折扣方式 Tab -->
                <Row
                  style="align-items: center; display: flex; margin-bottom: 8px"
                >
                  <Col span="3" style="color: #666; padding-left: 12px">折扣方式</Col>
                  <Col span="21">
                    <RadioGroup
                      type="button"
                      button-style="solid"
                      v-model="item.discountType"
                      @on-change="(val) => handleDiscountTypeChange(index, val)"
                    >
                      <Radio :value="0" :label="0"
                        >折价</Radio
                      >
                      <Radio :value="1" :label="1" :disabled="form.goodsType == 1"
                        >赠送奖励</Radio
                      >
                    </RadioGroup>
                  </Col>
                </Row>

                <!-- 全局配置：折价→ 三方支付价格 + 三方前N周折扣；赠送奖励→ 仅赠送金币数 -->
                <Row
                  v-if="item.discountType === 0"
                  style="
                    padding: 12px;
                    background: #fafafa;
                    border-radius: 4px;
                  "
                >
                  <Col span="12">
                    <FormItem
                      label="三方支付价格"
                      :label-width="120"
                      style="margin-bottom: 0"
                    >
                      <InputNumber
                        v-model="item.discountPrice"
                        :min="0"
                        :max="99999"
                        placeholder="请输入价格"
                        style="width: 100%"
                      />
                    </FormItem>
                  </Col>
                  <Col span="12" v-if="form.goodsType != 0">
                    <FormItem
                      :label="'三方前N' + discountPeriodUnit + '折扣'"
                      :label-width="130"
                      style="margin-bottom: 0"
                    >
                      <InputNumber
                        v-model="item.discountPeriod"
                        :min="0"
                        :precision="0"
                        :max="99999"
                        :placeholder="'请输入N' + discountPeriodUnit"
                        style="width: 100%"
                      />
                    </FormItem>
                  </Col>
                </Row>
                <Row
                  v-if="item.discountType === 1"
                  style="
                    padding: 12px;
                    background: #fafafa;
                    border-radius: 4px;
                  "
                >
                  <Col span="12">
                    <FormItem
                      label="赠送金币数"
                      :label-width="120"
                      style="margin-bottom: 0"
                    >
                      <InputNumber
                        v-model="item.giftCoins"
                        :min="0"
                        :precision="0"
                        :max="99999"
                        style="width: 100%"
                        placeholder="请输入赠送金币数"
                      />
                    </FormItem>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
          <FormItem label="排序：">
            <InputNumber :min="0" v-model="form.goodsSort" :max="99999" />
          </FormItem>
        </Form>
      </div>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit()"
          >提交</Button
        >
      </template>
    </Modal>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import MultiCascader from '@/components/MultiCascader'
import { getDictionaryList } from '@/api/dictionary'
import {
  getGoodsList,
  addGoods,
  delGoods,
  editGoods,
  getGoodsInfo,
  changeFirstCharge,
  changeStatus,
  check
} from '@/api/goods'
export default {
  components: {
    Pages,
    MultiCascader
  },
  data() {
    return {
      activeTab: 'ios',
      editVisible: false,
      form: {
        goodsNum: 0,
        vipExpireTime: 0,
        vipOriginalPrice: 0,
        goodsReward: 0,
        goodsDayReward: 0,
        goodsSort: 0,
        discountPeriodCount: null,
        goodsPrice: 0,
        isShowDiscount: false,
        thirdDiscountList: [
          { status: 0, discountPrice: null, discountPeriod: null, giftCoins: null, discountType: 0, payProvider: 0, payMethod: null },
          { status: 0, discountPrice: null, discountPeriod: null, giftCoins: null, discountType: 0, payProvider: 1, payMethod: null },
          { status: 0, discountPrice: null, discountPeriod: null, giftCoins: null, discountType: 0, payProvider: 2, payMethod: null }
        ]
      },
      thirdDiscountChannels: {
        stripe: { label: 'Stripe' },
        antom: { label: 'Antom' },
        paypal: { label: 'Paypal' }
      },
      thirdPaySubChannels: {
        card: { label: '卡支付' },
        apple: { label: 'Apple Pay' },
        google: { label: 'Google Pay' }
      },
      submitLoading: false,
      searchForm: {
        goodsChannel: '0',
        countryCodeList: []
      },
      dict: {
        channel: [
          {
            key: 0,
            value: 'IOS'
          },
          {
            key: 1,
            value: 'Android'
          },
          {
            key: 2,
            value: 'Web'
          }
        ],
        changeType: [
          {
            key: 2,
            value: '通行证'
          },
          {
            key: 1,
            value: 'VIP'
          },
          {
            key: 0,
            value: '金币充值'
          }
        ]
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableLoading: false,
      tableData: [],
      columns: [
        // {
        //   title: 'id',
        //   width: 50,
        //   key: 'id'
        // },
        {
          title: '付费项名称',
          key: 'goodsName',
          tooltip: true,
          width: 200,
          render: (h, params) => {
            return <div>{params.row.goodsName || '-'}</div>
          }
        },
        {
          title: '国家',
          key: 'countryList',
          width: 200,
          render: (h, params) => {
            if (params.row.worldWide) {
              return <div>默认</div>
            }
            return (
              <Tooltip
                style="width: 100%"
                max-width={500}
                transfer
                content={params.row.countryList
                  .map((i) => i.countryCname)
                  .join('、')}
              >
                <div style="white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
                  {params.row.countryList.map((i) => i.countryCname).join('、')}
                </div>
              </Tooltip>
            )
          }
        },
        {
          title: '付费类型',
          key: 'goodsTypeName',
          render: (h, params) => {
            return <div>{params.row.goodsTypeName || '-'}</div>
          }
        },
        {
          title: 'VIP时长',
          key: 'vipExpireTime',
          render: (h, params) => {
            if (params.row.goodsChannel == 1 && params.row.goodsType == 1) {
              return (
                <div>
                  {
                    [
                      '一周',
                      '四周',
                      '一个月',
                      '两个月',
                      '三个月',
                      '四个月',
                      '六个月',
                      '八个月',
                      '一年'
                    ][params.row.vipExpireTime - 1]
                  }
                </div>
              )
            } else {
              return <div>{params.row.vipExpireTime != null ? params.row.vipExpireTime : '-'}</div>
            }
          }
        },

        {
          title: '金币数',
          key: 'goodsNum',
          render: (h, params) => {
            return <div>{params.row.goodsNum != null ? params.row.goodsNum : '-'}</div>
          }
        },
        {
          title: '赠币数',
          width: 100,
          key: 'goodsReward',
          render: (h, params) => {
            return <div>{params.row.goodsReward != null ? params.row.goodsReward : '-'}</div>
          }
        },
        {
          title: '价格(美元)',
          key: 'goodsPrice',
          width: 100,
          render: (h, params) => {
            return <div>{params.row.goodsPrice != null ? params.row.goodsPrice : '-'}</div>
          }
        },
        {
          title: '内购折扣价',
          key: 'discountGoodsPrice',
          width: 100,
          render: (h, params) => {
            return <div>{params.row.discountGoodsPrice != null ? params.row.discountGoodsPrice : '-'}</div>
          }
        },
        {
          title: '状态',
          slot: 'goodsStatus',
          width: 100
        },
        {
          title: '排序值',
          key: 'goodsSort',
          width: 100,
          render: (h, params) => {
            return <div>{params.row.goodsSort != null ? params.row.goodsSort : '-'}</div>
          }
         },
        {
          title: '操作',
          align: 'center',
          width: 120,
          slot: 'action'
        }
      ],
      countryLi: []
    }
  },
  computed: {
    discountPeriodUnit() {
      const map = { 7: '周', 30: '月', 365: '年' }
      return map[this.form.vipExpireTime] || '周'
    },
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('fee/fee')
      const obj = {}
      li.forEach((i) => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods: {
    getData(page) {
      this.tableLoading = true
      if (page) this.page.current = page
      else this.page.current = 1

      const payload = {
        ...this.page,
        ...this.searchForm,
        goodsChannel: Number(this.searchForm.goodsChannel),
        goodsVersion: 1

      }
      if (payload.countryCodeList && payload.countryCodeList.length > 0) {
        payload.countryCodeList = payload.countryCodeList.join(',')
      } else {
        delete payload.countryCodeList
      }

      getGoodsList(payload).then(({ data }) => {
        this.tableData = (data.records || []).map((item) => ({
          ...item,
          discountStatus: !!item.discountStatus
        }))
        this.page.current = Number(data.current)
        this.page.total = Number(data.total)
      }).finally(() => {
        this.tableLoading = false
      })
    },
    changeChannel() {
      this.form.vipExpireTime = null
      this.form.thirdReward = ''
    },
    channelLabel(payProvider) {
      const map = { 0: 'Stripe', 1: 'Antom', 2: 'Paypal' }
      return map[payProvider] || ''
    },
    async handleGetCountry() {
      await getDictionaryList({ dictTopic: 'GOODS_COUNTRY_GROUP' }).then(
        (r) => {
          const data = r.data.records.map((i) => {
            return {
              label: i.dictName,
              value: i.dictName,
              children: i.dictValue.split(',').map((j) => {
                return {
                  value: j.split('|')[0],
                  label: j.split('|')[1]
                }
              })
            }
          })
          this.countryLi = [...data]
        }
      )
    },
    async handleOpenEditModal(row) {
      await this.handleGetCountry()
      this.form = {
        goodsNum: 0,
        vipExpireTime: 0,
        vipOriginalPrice: 0,
        goodsReward: 0,
        goodsDayReward: 0,
        goodsSort: 0,
        discountPeriodCount: null,
        thirdReward: null,
        worldWide: true,
        goodsPrice: 0,
        isShowDiscount: false,
        thirdDiscountList: [
        { status: 0, discountPrice: null, discountPeriod: null, giftCoins: null, discountType: 0, payProvider: 0, payMethod: null },
        { status: 0, discountPrice: null, discountPeriod: null, giftCoins: null, discountType: 0, payProvider: 1, payMethod: null },
        { status: 0, discountPrice: null, discountPeriod: null, giftCoins: null, discountType: 0, payProvider: 2, payMethod: null }
      ]
      }
      if (row) {
        const r = await getGoodsInfo(row.id)
        // 深合并：以初始化数组为底，用 API 数据按 payProvider 匹配覆盖
        const apiList = r.data.thirdDiscountList || []
        const mergedList = this.form.thirdDiscountList.map((base) => {
          const api = apiList.find((a) => a.payProvider === base.payProvider) || {}
          return {
            status: api.status !== undefined ? api.status : base.status,
            discountPrice: api.discountPrice !== undefined ? api.discountPrice : base.discountPrice,
            discountPeriod: api.discountPeriod !== undefined ? api.discountPeriod : base.discountPeriod,
            giftCoins: api.giftCoins !== undefined ? api.giftCoins : base.giftCoins,
            discountType: api.discountType !== undefined ? api.discountType : base.discountType,
            payProvider: base.payProvider,
            payMethod: api.payMethod !== undefined ? api.payMethod : base.payMethod
          }
        })
        const mergedData = { ...r.data, thirdDiscountList: mergedList }
        this.form = { ...this.form, ...mergedData }
        this.form.discountStatus = !!this.form.discountStatus

        this.form.countryCodeList = r.data.countryList.map((i) => i.countryCode)
      }
      this.editVisible = true
    },
    handleSyncThirdDiscount(e) {
      e.target.blur()
      const source = this.form.thirdDiscountList[0]
      this.form.thirdDiscountList.forEach((item, index) => {
        if (index === 0) return
        item.status = source.status
        item.discountType = source.discountType
        item.discountPrice = source.discountPrice
        item.discountPeriod = source.discountPeriod
        item.giftCoins = source.giftCoins
      })
    },
    handleThirdDiscountToggle(index, val) {
      const item = this.form.thirdDiscountList[index]
      this.$set(item, 'status', val)
      if (val === 0) {
        this.$set(item, 'discountPrice', null)
        this.$set(item, 'discountPeriod', null)
        this.$set(item, 'giftCoins', null)
        this.$set(item, 'discountType', 0)
        this.$set(item, 'payMethod', null)
      }
    },
    handleDiscountTypeChange(index, val) {
      const item = this.form.thirdDiscountList[index]
      if (val === 0) {
        this.$set(item, 'giftCoins', null)
      } else if (val === 1) {
        this.$set(item, 'discountPrice', null)
        this.$set(item, 'discountPeriod', null)
      }
    },
    handleDiscountTypeChange(index, val) {
      const item = this.form.thirdDiscountList[index]
      if (val === 0) {
        this.$set(item, 'giftCoins', null)
      } else if (val === 1) {
        this.$set(item, 'discountPrice', null)
        this.$set(item, 'discountPeriod', null)
      }
    },
    handleDiscountTypeChange(index, val) {
      const item = this.form.thirdDiscountList[index]
      if (val === 0) {
        this.$set(item, 'giftCoins', null)
      } else if (val === 1) {
        this.$set(item, 'discountPrice', null)
        this.$set(item, 'discountPeriod', null)
      }
    },

    handleSubmit() {
      this.$refs.formRef.validate((r) => {
        if (r) {
          if (this.form.goodsType === 1) {
            this.form.goodsNum = null
            this.form.goodsReward = null
          } else if (this.form.goodsType == 0) {
            this.form.vipExpireTime = null
            this.form.vipOriginalPrice = null
            this.form.goodsDesc = null
          } else {
            this.form.vipOriginalPrice = null
            this.form.goodsDesc = null
          }
          // Process Toggle switches logic
          if (!this.form.isShowDiscount) {
            this.form.discount = 0
            this.form.iosDiscountOfferId = null
          }
          this.form.thirdDiscountList.forEach((item) => {
            if (!item.status) {
              item.discountPrice = null
              item.discountPeriod = null
            }
          })
          // 提交时移除 discountType 字段，discountStatus 转数字
          const submitData = {
            ...this.form,
            discountStatus: this.form.discountStatus ? 1 : 0,
            thirdDiscountList: this.form.thirdDiscountList
          }
          this.submitLoading = true
          if (this.form.id) {
            check({
              channel: this.form.goodsChannel,
              goodsId: this.form.id,
              status: this.form.goodsStatus,
              type: this.form.goodsType
            }).then((r) => {
              if (r.data.isWindow) {
                this.$Modal.confirm({
                  title: '提示',
                  render: () => {
                    return (
                      <div>
                        该付费模板已被:
                        {r.data.list.map((i) => i.templateName).join(',')}
                        使用,继续执行该操作吗？
                      </div>
                    )
                  },
                  onOk: () => {
                    editGoods({
                      ...submitData,
                      goodsVersion: 1
                    })
                      .then((r) => {
                        this.$Message.success('操作成功')
                        this.getData()
                        this.submitLoading = false
                        this.editVisible = false
                      })
                      .catch(() => {
                        this.submitLoading = false
                      })
                  },
                  onCancel: () => {
                    this.submitLoading = false
                  }
                })
              } else {
                editGoods({
                  ...submitData,
                  discount: this.form.discount || 0,
                  goodsVersion: 1
                })
                  .then((r) => {
                    this.$Message.success('操作成功')
                    this.getData()
                    this.submitLoading = false
                    this.editVisible = false
                  })
                  .catch(() => {
                    this.submitLoading = false
                  })
              }
            })
          } else
            addGoods({
              ...submitData,
              goodsVersion: 1
            })
              .then((r) => {
                this.$Message.success('操作成功')
                this.getData()
                this.submitLoading = false
                this.editVisible = false
              })
              .catch(() => {
                this.submitLoading = false
              })
        }
      })
    },
    handleChangeStatus(row, newVal) {
      const prevStatus = row.goodsStatus
      row.goodsStatus = newVal ? 0 : 1
      this.tableLoading = true
      check({
        channel: row.goodsChannel,
        goodsId: row.id,
        status: newVal ? 0 : 1,
        type: row.goodsType
      }).then((r) => {
        if (r.data.isWindow) {
          this.$Modal.confirm({
            title: '提示',
            render: () => {
              return (
                <div>
                  该付费已被模板:
                  {r.data.list.map((i) => i.templateName).join(',')}
                  使用,继续执行该操作吗？
                </div>
              )
            },
            onOk: () => {
              changeStatus(row.id)
                .then(() => {
                  this.$Message.success('操作成功')
                  this.getData(this.page.current)
                })
                .catch(() => {
                  row.goodsStatus = prevStatus
                  this.tableLoading = false
                  this.$Message.error('操作失败')
                })
            },
            onCancel: () => {
              row.goodsStatus = prevStatus
              this.tableLoading = false
            }
          })
        } else {
          changeStatus(row.id)
            .then(() => {
              this.$Message.success('操作成功')
              this.getData(this.page.current)
            })
            .catch(() => {
              row.goodsStatus = prevStatus
              this.$Message.error('操作失败')
            })
        }
      }).catch(() => {
        row.goodsStatus = prevStatus
        this.tableLoading = false
        this.$Message.error('操作失败')
      })
    },
    handleChangeFirstCharge(row) {
      check({
        goodsId: row.id
      }).then((r) => {
        if (r.data.isWindow) {
          this.$Modal.confirm({
            title: '提示',
            render: () => {
              return (
                <div>
                  该付费已被模板:
                  {r.data.list.map((i) => i.templateName).join(',')}
                  使用,继续执行该操作吗？
                </div>
              )
            },
            onOk: () => {
              changeFirstCharge(row.id)
                .then((r) => {
                  this.$Message.success('操作成功')
                  this.getData()
                })
                .catch((e) => {
                  this.$Message.error('操作失败')
                })
            }
          })
        } else {
          changeFirstCharge(row.id)
            .then((r) => {
              this.$Message.success('操作成功')
              this.getData()
            })
            .catch((e) => {
              this.$Message.error('操作失败')
            })
        }
      })

      return new Promise(() => {})
    },
    handleChangeDiscountStatus(row) {
      const newVal = row.discountStatus ? 1 : 0
      editGoods({ id: row.id, discountStatus: newVal, goodsVersion: 1 })
        .then(() => {
          this.$Message.success('操作成功')
          this.getData(this.page.current)
        })
        .catch(() => {
          this.$Message.error('操作失败')
        })
      return new Promise(() => {})
    },
    handleDel(row) {
      check({
        goodsId: row.id
      }).then((r) => {
        if (r.data.isWindow) {
          this.$Modal.confirm({
            title: '提示',
            render: () => {
              return (
                <div>
                  该付费已被模板:
                  {r.data.list.map((i) => i.templateName).join(',')}
                  使用,继续执行该操作吗？
                </div>
              )
            },
            onOk: () => {
              delGoods(row.id).then((r) => {
                this.$Message.success('操作成功')
                this.getData()
              })
            }
          })
        } else {
          delGoods(row.id).then((r) => {
            this.$Message.success('操作成功')
            this.getData()
          })
        }
      })
    },
    handleReset() {
      this.searchForm = {
        goodsChannel: this.searchForm.goodsChannel,
        countryCodeList: [],
      }
    }
  },
  mounted() {
    this.handleGetCountry()
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;

  & > * {
    margin: 0 5px;
  }
}

.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}

.toolbar-row {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}
</style>
